import { getSafe } from "../../../util/storeHelper";
/**
 * generate the category's subtitle
 *
 * @param {string} rootId
 * @param {any} mods
 * @return {string}
 */
function generateSubtitle(t, categoryId, mods, totalChildModCount) {
    const modsCount = getSafe(mods, [categoryId], []).length;
    let subt = modsCount === 0
        ? t("Empty")
        : t("{{ count }} mods installed", { count: modsCount });
    if (totalChildModCount !== undefined && totalChildModCount > 0) {
        subt =
            subt +
                t(" ({{ count }} mods in sub-categories)", { count: totalChildModCount });
    }
    return subt;
}
export default generateSubtitle;
